import { jsx as _jsx } from "react/jsx-runtime";
function IconHomeFilled(props) {
    return (_jsx("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconHomeFilled", ...props, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.089L3 9.998v12h7v-5h4v5h7v-12l-9-7.91z", fill: "currentColor" }) }));
}
export default IconHomeFilled;
//# sourceMappingURL=IconHomeFilled.js.map